export {default} from '../../../core/components/AppMenu/AppMenuItemRoutes';
